import React from "react";
import { useState } from "react";
import FirstStep from "../FirstStep";

function TranslateTo({
  setCallAPI,
  data,
  TranslateToRef,
  setTransToOpen,
  TransToOpen,
  storeValue,
  transtalteFromInput,
  TranslateFromstyles,
  TranslateTostyles,
  ToSearchInput,
  handleTranslateToInput,
  setToSearchInput,
  handleRemoveLanguage,
  errorTwo,
  newError,
  setNewError,
  transtalteToInput,
  setErrorTwo
}) {
  const HandleStates = () => {
    if (transtalteFromInput === undefined) {
      setNewError(true);
    } else {
      setTransToOpen(!TransToOpen);
      setCallAPI(true);
    }
    // console.log(transtalteFromInput);
  };

  if(transtalteToInput == undefined){
    setErrorTwo(false)
  }

  const [targetLang, setTargetLang] = useState(true);
  // const [ newError, setNewError ] = useState(false);


if(storeValue.length > 0 ){
  setErrorTwo(false)
}

 
// console.log(storeValue)
  return (
    <label
      className="flex flex-col w-full font-opensans mb-5 cursor-pointer items-center"
      ref={TranslateToRef}
    >
      <div className="w-full">
        <span className="text-[18px] font-opensans">Translate to</span>
        <div className=" w-full lg:w-[325px] min-w-[300px] font-arial group relative ">
          <div
            className={`min-h-[50px] px-4 bg-white  border-quotetext-100 rounded-xl border w-full border-solid text-[#777777] mb-1 flex items-center justify-between`}
            onClick={HandleStates}
          >
            <p className=" flex flex-wrap w-11/12">
              {storeValue.length === 0
                ? "Select target language"
                : storeValue?.map((value) => (
                    <span className=" mr-1 px-2 py-1 rounded-2xl bg-gray my-1">
                      {value}{" "}
                      <span
                        className="text-quotetext-200"
                        onClick={() => handleRemoveLanguage(value)}
                      >
                        &#x2717;
                      </span>
                    </span>
                  ))}
            </p>
            <span
              className={` text-quotetext-200 arrow ${
                TransToOpen ? "rotate-[316deg]" : "rotate-[135deg]"
              }  transition-all duration-200 ease-linear inline-block `}
            ></span>
          </div>

          {transtalteFromInput === "Select source language" ? null : (
            <>
              <input
                placeholder="Search..."
                style={TranslateFromstyles}
                type="text"
                className="h-[50px] px-4 bg-white  border-quotetext-100 rounded-tl-lg rounded-tr-lg outline-none border w-full border-solid text-[#777777]  flex items-center justify-between"
                value={ToSearchInput}
                style={TranslateTostyles}
                onChange={(e) => setToSearchInput(e.target.value)}
                
              />
              <ul
                className="rounded-bl-lg rounded-br-lg max-h-[350px] visible absolute z-50 w-full  overflow-y-scroll bg-white border-quotetext-100 border-solid border"
                style={TranslateTostyles}
              >
                {data
                  ? data?.data
                      ?.filter(
                        (optionValue) =>
                          optionValue.source_language === transtalteFromInput
                      )
                      ?.map(({ target_language }) =>
                        target_language
                          ?.filter((value) => {
                            if (ToSearchInput === "") {
                              return value;
                            } else if (
                              value
                                .toLowerCase()
                                .includes(ToSearchInput.toLowerCase())
                            ) {
                              return value;
                            }
                          })
                          ?.map((value, index) => (
                            <div
                              className={`flex justify-between items-center ${
                                targetLang ? "block" : "hidden"
                              } ${storeValue.includes(value) ? "bg-gray" : ""}`}
                              key={index}
                            >
                                          {/* {console.log(ToSearchInput)} */}

                              <li
                                className="h-[50px] px-4 w-full text-[#777777] flex items-center justify-between"
                                onClick={() => handleTranslateToInput(value)}
                              >
                                {value}
                              </li>
                              {storeValue.includes(value) ? (
                                <span
                                  className="text-xl text-white w-4 h-4 bg-orange font-secondary mr-4 leading-[0.8] text-center"
                                  onClick={() => handleRemoveLanguage(value)}
                                >
                                  &#10003;
                                </span>
                              ) : (
                                <span
                                  className="text-xl text-[#777777] font-secondary px-4 py-2 hover:text-2xl"
                                  onClick={() => handleTranslateToInput(value)}
                                >
                                  +
                                </span>
                              )}
                              <input
                                type="button"
                                value=""
                                placeholder="searvch"
                              />
                            </div>
                          ))
                      )
                  : null}

                {/* --------------addonbutton-------------- */}
                {targetLang ? (
                  <button
                    className="h-[50px] px-4 w-full text-[#777777]"
                    onClick={() => setTargetLang(false)}
                  >
                    More available languages
                  </button>
                ) : null}

                <div
                  className="rounded-bl-lg rounded-br-lg visible z-50 w-full bg-white border-quotetext-100 border-solid border"
                  style={TranslateTostyles}
                >
                  {data
                    ? data?.data
                        ?.filter(
                          (optionValue) =>
                            optionValue.source_language === transtalteFromInput
                        )
                        ?.map(({ target_language_2 }) =>
                          target_language_2
                            ?.filter((value) => {
                              if (ToSearchInput === "") {
                                return value;
                              } else if (
                                value
                                  .toLowerCase()
                                  .includes(ToSearchInput.toLowerCase())
                              ) {
                                return value;
                              }
                            })
                            ?.map((value, index) => (
                              <div
                                className={` justify-between items-center ${
                                  targetLang ? " hidden " : " flex"
                                } ${
                                  storeValue.includes(value) ? "bg-gray" : ""
                                }`}
                                key={index}
                              >
                                <li
                                  className="h-[50px] px-4 w-full text-[#777777] flex items-center justify-between"
                                  onClick={() => handleTranslateToInput(value)}
                                >
                                  {value}
                                </li>
                                {storeValue.includes(value) ? (
                                  <span
                                    className="text-xl text-white w-4 h-4 bg-orange font-secondary mr-4 leading-[0.8] text-center"
                                    onClick={() => handleRemoveLanguage(value)}
                                  >
                                    &#10003;
                                  </span>
                                ) : (
                                  <span
                                    className="text-xl text-[#777777] font-secondary px-4 py-2 hover:text-2xl"
                                    onClick={() =>
                                      handleTranslateToInput(value)
                                    }
                                  >
                                    +
                                  </span>
                                )}
                              </div>
                            ))
                        )
                    : null}
                </div>
                {/* --------------addonbutton-------------- */}
              </ul>
            </>
          )}
        </div>
        {errorTwo && <span className="text-red block">This field is required.</span>}{" "}
        {newError && <span className="text-red block">Select source language</span>}{" "}
      </div>
    </label>
  );
}

export default TranslateTo;
